import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

export const LanguageSwitcher: React.FC = () => {
    const { i18n } = useTranslation();

    const toggleLanguage = () => {
        const newLang = i18n.language === 'pt' ? 'en' : 'pt';
        i18n.changeLanguage(newLang);
    };

    return (
        <button
            onClick={toggleLanguage}
            className="p-2 bg-gray-700 rounded-full hover:bg-gray-600 transition-colors flex items-center justify-center"
            title={i18n.language === 'pt' ? 'Mudar para Inglês' : 'Switch to Portuguese'}
        >
            <Globe className="w-5 h-5 text-white" />
            <span className="ml-2 text-white text-sm font-bold uppercase">
                {i18n.language}
            </span>
        </button>
    );
};
